/* eslint-disable react/jsx-key */
import "./UsersTable.scss";
import useUsersTableLogic from "./UsersTableLogic";
import secondaryComponents from "..";

const UsersTable = () => {
  const {
    instance,
    isFetchingUsers,
    showInviteModal,
    setShowInviteModal,
    userRole,
    userEmail,
    storeAccessList,
    subAccountList,
    fetchUsersList,
    showDeleteUserModal,
    setShowDeleteUserModal,
  } = useUsersTableLogic();
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <secondaryComponents.LoaderHelper
      isLoading={isFetchingUsers}
      classNames="mt-5"
    >
      <div className="users-table">
        <secondaryComponents.TableHelper
          getTableProps={getTableProps}
          getTableBodyProps={getTableBodyProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          hasAction={true}
        >
          <div className="text-center mt-5">
            <h4>You have not invited anyone yet</h4>
            <p>When you do, the users would appear here.</p>
          </div>
        </secondaryComponents.TableHelper>
      </div>

      {/* edit user role modal */}
      {showInviteModal && (
        <secondaryComponents.EditInviteUser
          setShowInviteModal={setShowInviteModal}
          showInviteModal={showInviteModal}
          userEmail={userEmail}
          userRole={userRole}
          storeAccessList={storeAccessList}
          fetchUsersList={fetchUsersList}
          subAccountList={subAccountList}
        />
      )}

      {/* delete user modal */}
      {showDeleteUserModal && (
        <secondaryComponents.DeleteInvitedUser
          setShowDeleteUserModal={setShowDeleteUserModal}
          showDeleteUserModal={showDeleteUserModal}
          userEmail={userEmail}
          fetchUsersList={fetchUsersList}
        />
      )}
    </secondaryComponents.LoaderHelper>
  );
};

export default UsersTable;
